function t(a) {
  return this.__data__.has(a);
}
export {
  t as default
};
